export const formatLeaveDays = (value: number | string | null | undefined) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const number = Number(value);

    if (!Number.isFinite(number)) {
        return '';
    }

    return number.toLocaleString('en-US', {
        maximumFractionDigits: 4,
        useGrouping: false
    });
};
